import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { thunkInitializeAuth } from "../store/authThunks";
import { logout } from "../store/authSlice";
import type { AppDispatch } from "@/app/store";
import { TokenStorageService } from "@/shared/services/tokenStorage.service";

export const AuthInitializer = () => {
  const dispatch = useDispatch<AppDispatch>();

  useEffect(() => {
    dispatch(thunkInitializeAuth());
  }, [dispatch]);

  useEffect(() => {
    if (typeof BroadcastChannel === "undefined") return;

    const channel = new BroadcastChannel("auth");
    channel.onmessage = (event) => {
      if (event.data.type === "LOGIN") {
        // Sync token from other tab
        if (event.data.token) {
          TokenStorageService.setToken(event.data.token);
        }
        dispatch(thunkInitializeAuth());
      } else if (event.data.type === "LOGOUT") {
        TokenStorageService.clearToken();
        dispatch(logout());
        window.location.href = "/auth";
      }
    };

    return () => channel.close();
  }, [dispatch]);

  useEffect(() => {
    const handleUnauthorized = () => {
      TokenStorageService.clearToken();
      dispatch(logout());
      window.location.href = "/auth";
    };

    window.addEventListener("auth:unauthorized", handleUnauthorized);
    return () => window.removeEventListener("auth:unauthorized", handleUnauthorized);
  }, [dispatch]);

  return null;
};
